/**
 * com.remedirx.apps.MyRemedi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { EmbeddedResource } from './embeddedResource';
import { Link } from './link';
import { NursingStation } from './nursingStation';
import { Prescriber } from './prescriber';


/**
 * Active Controlled Medications Report Options
 */
export interface ActiveControlledMedicationOptions { 
    /**
     * Include Gabapentin
     */
    IncludeGabapentin?: boolean;
    /**
     * Order Type
     */
    OrderType?: ActiveControlledMedicationOptions.OrderTypeEnum;
    /**
     * Nursing Stations
     */
    NursingStations?: Array<NursingStation>;
    /**
     * Prescribers
     */
    Prescribers?: Array<Prescriber>;
    /**
     * Id of the object if there is one.  Some summary screens will not populate this value
     */
    Id?: string;
    _links?: Array<Link>;
    _embedded?: Array<EmbeddedResource>;
}
export namespace ActiveControlledMedicationOptions {
    export type OrderTypeEnum = 'NonProfileOnly' | 'ProfileOnly' | 'Both';
    export const OrderTypeEnum = {
        NonProfileOnly: 'NonProfileOnly' as OrderTypeEnum,
        ProfileOnly: 'ProfileOnly' as OrderTypeEnum,
        Both: 'Both' as OrderTypeEnum
    };
}
